import { useEffect, useRef, useState } from "react";
import DataHandlerHelper from "../../helpers/DataHandler.helper";
import { useNavigate } from "react-router-dom";
import clientsApi from "../../api/client/client";
import trainingCategoryApi from "../../api/trainingCategory/trainingCategory";
import clientApi from "../../api/client";
import { ui } from "../../helpers/ui";

const InitClientUpdateLogic = () => {
  const navigate = useNavigate();
  const [clients, setClients] = useState<any[]>([]);
  const [selectedClient, setSelectedClient] = useState<any>();
  const [categories, setCategories] = useState<any[]>([]);
  // Cene kao STRING (polje moze da bude prazno dok se kuca); broj tek na cuvanje.
  const [prices, setPrices] = useState<Record<number, string>>({});
  const [credentials, setCredentials] = useState<{username: string; password: string}>({username: "", password: ""});
  const firstNameRef = useRef<any>();
  const lastNameRef = useRef<any>();
  const phoneRef = useRef<any>();
  const [data, setData] = useState<any>({
    client: "",
  });

  const loadCategories = () => {
    trainingCategoryApi
      .getAll()
      .then((response) => {
        if (response.status === 200) {
          setCategories(response.data);
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  const onSubmit = async () => {
    if (!selectedClient) {
      ui.alert("Izaberite klijenta pre čuvanja.");
      return;
    }
    // Cena je obavezna za svaki tip (broj >= 0) - da se ne upise prazno/0.
    const numericPrices: Record<number, number> = {};
    for (const [ttId, raw] of Object.entries(prices)) {
      const num = Number(raw);
      if (raw === undefined || raw === "" || isNaN(num) || num < 0) {
        const tt = categories
          .flatMap((c: any) => c.trainingTypes || [])
          .find((t: any) => t.id === +ttId);
        ui.alert(`Unesite cenu za "${tt?.name ?? "trening"}".`);
        return;
      }
      numericPrices[+ttId] = num;
    }
    const confirmed = await ui.confirm("Sigurno želite da sačuvate?");
    if (!confirmed) return;
    const updateData: any = {
      firstName: selectedClient.firstName,
      lastName: selectedClient.lastName,
      phone: selectedClient.phone,
    };
    if (credentials.username && credentials.username !== selectedClient.user?.username) {
      updateData.username = credentials.username;
    }
    if (credentials.password) {
      updateData.password = credentials.password;
    }
    clientsApi
      .updateClient(updateData, selectedClient.id)
      .then(async (response) => {
        if (response.status === 204) {
          // Ažuriraj cene (vec validirane u numericPrices)
          for (const [ttId, price] of Object.entries(numericPrices)) {
            const existingPrice = selectedClient.prices?.find(
              (p: any) => p.trainingTypeId === +ttId
            );
            if (existingPrice) {
              await clientApi.patch(`/client-prices/${existingPrice.id}`, {
                price,
              });
            } else {
              await clientApi.post("/client-prices", {
                clientId: selectedClient.id,
                trainingTypeId: +ttId,
                price,
              });
            }
          }
          ui.toast("Sačuvano", "success");
          navigate("/home");
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  const onDeleteClient = async () => {
    if (!selectedClient) {
      ui.alert("Izaberite klijenta.");
      return;
    }
    const confirmed = await ui.confirm(
      `Obrisati klijenta ${selectedClient.firstName} ${selectedClient.lastName} i SVE povezane podatke (uplate, treninge, stanje, zakazivanja, pristup)? Ovo se ne može poništiti.`
    );
    if (!confirmed) return;
    clientsApi
      .deleteClient(selectedClient.id)
      .then(() => {
        ui.toast("Klijent obrisan", "success");
        navigate("/home");
      })
      .catch((e) => ui.alert(e.response?.data?.error?.message || "Greška"));
  };

  const onChange = (event: any) => {
    setSelectedClient(
      DataHandlerHelper.handleInputChange(event, { ...selectedClient })
    );
  };

  const onChangeSearch = (event: any) => {
    setData(DataHandlerHelper.handleInputChange(event, { ...data }));
  };

  const onPriceChange = (trainingTypeId: number, value: string) => {
    setPrices({ ...prices, [trainingTypeId]: value });
  };

  const onCredentialsChange = (event: any) => {
    setCredentials({ ...credentials, [event.target.name]: event.target.value });
  };

  const loadClients = () => {
    clientsApi
      .getAll()
      .then((response) => {
        if (response.status === 200) {
          setClients(response.data);
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  const selectClient = (client: any) => {
    // Zaštita od duplog klika: bez mutacije state niza
    if (selectedClient?.id === client.id) return;
    const rest = clients.filter((c: any) => c.id !== client.id);
    setClients(selectedClient !== undefined ? [...rest, selectedClient] : rest);
    setSelectedClient(client);
    // Popuni cene: prvo podrazumevane cene tipova, pa preko njih klijentove
    // izmene - ranije se za tip bez klijentove izmene prikazivala lažna nula
    const clientPrices: Record<number, string> = {};
    for (const category of categories) {
      for (const tt of category.trainingTypes || []) {
        clientPrices[tt.id] = String(tt.price ?? "");
      }
    }
    for (const p of client.prices || []) {
      clientPrices[p.trainingTypeId] = String(p.price ?? "");
    }
    setPrices(clientPrices);
    setCredentials({ username: client.user?.username || "", password: "" });
  };

  const removeSelectedClient = (client: any) => {
    setSelectedClient(undefined);
    setClients([...clients, client]);
    setData({ ...data, client: "" });
    setPrices({});
    setCredentials({ username: "", password: "" });
  };

  useEffect(() => {
    loadClients();
    loadCategories();
  }, []);

  return {
    selectedClient,
    clients,
    data,
    categories,
    prices,
    credentials,
    firstNameRef,
    lastNameRef,
    phoneRef,
    onSubmit,
    onDeleteClient,
    onChange,
    onChangeSearch,
    onPriceChange,
    onCredentialsChange,
    selectClient,
    removeSelectedClient,
  };
};

export default InitClientUpdateLogic;
